import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ReviewComponent from './ReviewComponent';
const PDPFabricReviewsUI = t0 => {
  const $ = _c(7);
  const {
    reviews,
    showTitle: t1
  } = t0;
  const showTitle = t1 === undefined ? true : t1;
  if (!reviews?.length) {
    return null;
  }
  let t2;
  if ($[0] !== showTitle) {
    t2 = showTitle && <h3 className="text-base font-bold m-0 pb-2 [border-bottom:1px_solid_#f1f1f1]">Reviews</h3>;
    $[0] = showTitle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reviews) {
    t3 = reviews.map(_temp);
    $[2] = reviews;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="mx-0 my-4">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
PDPFabricReviewsUI.propTypes = {
  reviews: PropTypes.array,
  showTitle: PropTypes.bool
};
export default PDPFabricReviewsUI;
function _temp(review) {
  return <ReviewComponent key={review.id} rate={review.rate} keyId={review.id} full_name={review.full_name} location={review.location} date={review.date} review={review.review} />;
}